var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircleBold = function SvgCheckCircleBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28564 17.5714L13.5321 20.9685C13.6461 21.0624 13.7797 21.1297 13.923 21.1656C14.0663 21.2014 14.2158 21.2048 14.3606 21.1756C14.5069 21.1482 14.6454 21.0896 14.767 21.0038C14.8885 20.918 14.9901 20.8071 15.0649 20.6785L21.7142 9.28564",
    stroke: "#000033",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4999 28.9642C22.936 28.9642 28.9642 22.936 28.9642 15.4999C28.9642 8.06381 22.936 2.03564 15.4999 2.03564C8.06381 2.03564 2.03564 8.06381 2.03564 15.4999C2.03564 22.936 8.06381 28.9642 15.4999 28.9642Z",
    stroke: "#000033",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCheckCircleBold;